import { Info } from 'lucide-react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ALLOW_WORK_ASSIGNMENT_TOOLTIP } from './allowWorkAssignment';

type AllowWorkAssignmentFieldProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export default function AllowWorkAssignmentField({
  id,
  checked,
  onCheckedChange,
}: AllowWorkAssignmentFieldProps) {
  return (
    <div className="tw:flex tw:items-center tw:gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
      />
      <Label htmlFor={id}>Allow Work Assignment</Label>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <span
                role="button"
                tabIndex={0}
                aria-label="About Allow Work Assignment"
                className="tw:inline-flex tw:shrink-0 tw:text-muted-foreground"
                onClick={(event) => event.preventDefault()}
                onPointerDown={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
              >
                <Info className="tw:h-3.5 tw:w-3.5" />
              </span>
            }
          />
          <TooltipContent side="bottom" className="tw:max-w-xs">
            {ALLOW_WORK_ASSIGNMENT_TOOLTIP}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
